module.exports = __webpack_public_path__ + "img/badge-3.b9342978.svg";